import React, {Component} from 'react'
import Field from '../../../struct/Field'
import InputText from 'lib/struct/form/InputText'
import {observer} from "mobx-react"
import ConditionsContext from "../../../../context/ConditionsContext"
import Hint from '../../../struct/Hint';
import Iconui from "lib/struct/iconui/Iconui";

@observer
export default class CampaignConditions extends Component {
    constructor(props) {
        super(props);
	      this.state = {
					conditions: props.context.conditions,
		      conditionContext: null
	      }
    }

		componentWillMount = () => {
			this.setCampaignCondition();
		}

		componentWillReceiveProps = () => {
			this.setCampaignCondition();
		}

		updateContext = () => {
	    const conditions = this.props.context.conditions;
	    const filteredConditions = conditions.filter((item) => item.campaign_id !== this.props.compaign.id)
	    const newConditions = [...filteredConditions, ...this.props.compaign.condition.conditionsArray]
	    this.props.changeConditions(newConditions)
		};

		setCampaignCondition = () => {
			/** @type ConditionsContext conditionContext */
			const conditionContext = this.props.compaign.condition
			this.setState({conditionContext})
		}

    render() {
        this.conditionContext = this.state.conditionContext
        const conditions = []
        let index = 0
        this.conditionContext.conditions.forEach((condition) => {
            conditions.push(this.conditionComponent(condition, index))
            index++
        })

        return (
            <Field label="Настройка подмены наличия" style={{margin: '0'}}>
                {conditions}
		            <div style={{marginTop: '10px'}}>
	                <a onClick={() => {
		                  this.conditionContext.addConditions(this.props.compaign.id)
	                    this.updateContext()
	                }}>
                        <Iconui name="add" />Добавить условие...
	                </a>
		            </div>
	              <Hint>Вместо реального наличия в ответе будет отправляться указанное здесь число. Для бесконечности используйте inf</Hint>
            </Field>

        )
    }

    /**
     *  @param condition {{type: string, if_value: string, then_value: number}}
     *  @param index {number}
     */
    conditionComponent(condition, index) {
				const styles = {
					display: 'flex',
					alignItems: 'center'
				}
	      if (index > 0) styles['marginTop'] = '5px';
        return <div key={index} style={styles}>
            Если у товара наличие {this.conditionsOptions(condition)}
            <input style={{width: '100px'}} type={'text'} value={condition.if_value} onChange={(e) => {condition.if_value = e.target.value;this.updateContext()}}/>,
            то ответить
            <input style={{width: '100px', margin: '0 5px'}} type={'number'} value={condition.then_value}
                   onChange={(e) => {condition.then_value = e.target.value;this.updateContext()}}/>
            <a onClick={() => {this.deleteCondition(condition)}}>
                <Iconui name="delete" />

            </a>
        </div>
    }

    /** @param condition {{type: string, if_value: string, then_value: number}}*/
    conditionsOptions(condition) {
        return <select
	          style={{margin: '0 5px'}}
            value={condition.type}
            onChange={(event) => {
                condition.type = event.target.value
                this.updateContext()
            }}>
            <option value={'='}>равно</option>
            <option value={'>'}>больше</option>
            <option value={'<'}>меньше</option>
        </select>
    }

    deleteCondition = (condition) => {
        this.props.context.conditions_to_delete.push(condition['id'])
        this.conditionContext.delCondition(condition)
        this.updateContext()
    }
}